export const ru = {
    'error-add': 'Ошибка! Не удалось добавить продукт',
    'error-change': 'Не удалось обновить продукт',
    'success-add': 'Продукт успешно добавлен',
    'success-change': 'Продукт успешно обновлен'
};
